import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationExtras, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { RedirectService } from './redirect.service';

@Injectable()
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private redirectService: RedirectService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url: string = state.url;
    console.log('canActivate. route: ', route, 'state: ', state);

    if (url.includes('?token=') && !url.startsWith('/login')) {
      // tokens are routed to / and should be processed immediately
      // clear the redirect to avoid a nearly impossible edge case
      this.redirectService.clearRedirect();
      this.redirectService.navigate('/login');
      return false;
    }
    else if(this.authService.isLoggedIn() && this.hasRedirectUrl()) {
      // Redirect stored. Go there.
      this.redirectService.redirect();
      return false;
    }
    else if (this.authService.isLoggedIn() && this.invalidPageForLoggedInUser(url)) {
      // Invalid page. Go to home.
      this.redirectService.redirect();
      return false;
    }
    else if (this.authService.isSessionExpired() && !url.startsWith('/login')) {
      // Valid page, session expired. Save route for processing after renewing login.
      this.authService.logout();
      this.redirectService.redirectUrl = url;
      this.redirectService.navigate('/login?expired=1');
      return false;
    }
    else if (!this.authService.isLoggedIn() && !url.startsWith('/login')) {
      // Not logged in. Save route for processing after login.
      this.redirectService.redirectUrl = url;
      this.redirectService.navigate('/login');
      return false;
    }
    
    return true;
  }

  invalidPageForLoggedInUser(url: string) {
    return ((url.startsWith('/login') && !url.includes('?token=')))
      || (url.startsWith('/support-tools') && !this.authService.isInternal());
  }

  hasRedirectUrl() {
    return this.redirectService.redirectUrl != null
      && this.redirectService.redirectUrl !== '';
  }
}
